// extracted by mini-css-extract-plugin
module.exports = {"Button":"BlueButton_Button__184iw"};